import script from "./DetailPageSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailPageSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./DetailPageSkeleton.vue?vue&type=style&index=0&id=21e92973&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21e92973"]])

export default __exports__